/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileNwf = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M14.414 2H4v20h16v-3h-2v1H6V4h7v5h5v1h2V7.586zm2.172 5H15V5.414z" />
        <path d="M8.25 17v-4.87h.965l2.104 3.168V12.13h1.031V17h-.964l-2.104-3.176V17zm5.768 0-1.079-4.87h1.059l.69 3.282.871-3.015h.864l.912 2.975.683-3.243h1.032L17.97 17h-1.005l-.998-3.276L15.023 17zm5.623-4.87V17h1.046v-1.876h1.829v-.884h-1.83v-1.226h2.064v-.885z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileNwf as FileNwf };
